import {Mode, Skin} from "@webbyx/mui";

export const createThemeOverrideSwitch = (mode: Mode, skin: Skin) => {
  return {
    MuiSwitch: {
      styleOverrides: {
        root: {
          '&.MuiSwitch-track': {
            borderRadius: '50px',
          },
        },
      },
    }
  }
}

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default createThemeOverrideSwitch;
